export const transformObjectKeys = (transformer, object) =>
  Object.keys(object).reduce((updatedObject, key) => {
    updatedObject[transformer(key)] = object[key];

    return updatedObject;
  }, {});
